import React from 'react';
import { isIE } from 'react-device-detect';

// import default view
import { lazyImage as LazyImageView } from './lazy-image.view';

/**
 * @type {function}
 * @desc A Higher-Order-Component to enhance functionality of `Component`
 * @param {object} Component - A React component
 * @example
 * import { lazyImage, LazyImage } from 'modules/lazy-image';
 *
 * // create a component
 * const ComponentWithHOC = lazyImage( CustomView );
 */
const lazyImage = ( Component = LazyImageView ) => {
    class LazyImage extends React.Component {
        constructor( props ) {
			super( props );

			// component state
			this.state = {
				isLoading: isIE ? false : true,
			};

			// start loading image
			if( ! isIE ) {
				this.loadImage();
			}
		}

		/**
		 * @desc start downloading image
		 */
		loadImage() {
			const image = new Image();

			// on image load, update state
			image.onload = () => {
				this.setState( { isLoading: false } );
			};

			// start loading image
			image.src = this.props.src;

		}

        render() {

			return (
				<Component
					{ ...this.props }
					isLoading = { this.state.isLoading }
				/>
			);
		}
    }

    // set display name
    LazyImage.displayName = 'LazyImage';

    // default props
    LazyImage.defaultProps = {};

    // prop types
    LazyImage.propTypes = {};

    // return component
    return LazyImage;
};

// export HOC
export { lazyImage };

// export react component with default view
export const LazyImage = lazyImage();
